import axios from '../api/index.js';

//查询详情-企业中心
export let getEntSysUserCenter = (params) => {
    return axios.get(`/client/ent/sys/user/center/${params}`);
};

//查询详情
export let getEntSysUser = (params) => {
    return axios.get(`/client/ent/sys/user/${params}`);
};

//修改
export let putEntSysUser = (params) => {
    return axios.put(`/client/ent/sys/user`,params);
};

//注册
export let postEntSysUser = (params) => {
    return axios.post(`/sys/user/business`, params);
};

//企业大会员申请(新建)
export let postEntMemberInfo = (params) => {
    return axios.post(`/client/ent/member/info`, params);
};

//企业大会员申请(修改)
export let putEntMemberInfo = (params) => {
    return axios.put(`/client/ent/member/info`, params);
};

//企业大会员 查询详情
export let getEntMemberInfo = (params) => {
    return axios.get(`/client/ent/member/info/${params}`);
};

//企业大会员 回显
export let getEntMemberInfoInfo = (params) => {
    return axios.get(`/client/ent/member/info/info/${params}`);
};

//分支机构--已获取列表
export let getEntMemberInfoDictList = (params) => {
    return axios.get(`/client/ent/branch/member/info/list/${params}`);
};

//分支机构档案列表
export let getEntBranchDictList = (params) => {
    return axios.post(`/client/ent/branch/dict/list`,params);
};

//查询可苞报名列表
export let getEntBranchDictEnrollList = (params) => {
    return axios.post(`/client/ent/branch/dict/enroll/list`,params);
};

//分支机构档案详情
export let getEntBranchDictDetail = (params) => {
    return axios.get(`/client/ent/branch/dict/${params}`);
};

//分支机构(新建)
export let postEntBranchMemberInfo = (params) => {
    return axios.post(`/client/ent/branch/member/info`, params);
};

//分支机构(修改)
export let putEntBranchMemberInfo = (params) => {
    return axios.put(`/client/ent/branch/member/info`, params);
};

//分支机构 (查询详情)
export let getEntBranchMemberInfo = (params) => {
    return axios.get(`/client/ent/branch/member/info/${params}`);
};

//分支机构(删除)
export let deleteEntBranchMemberInfo = (params) => {
    return axios.delete(`/client/ent/branch/member/info`, params);
};

//查询当前用户拥有的分支机构id
export let getEntBranchIdList = (params) => {
    return axios.get(`/client/ent/branch/news/branchIds/list?businessId=${params}`);
};

//分支机构新闻  查询列表
export let getEntBranchNewsList = (params) => {
    return axios.post(`/client/ent/branch/news/list`,params);
};

//分支机构新闻  查询详情
export let getEntBranchNewsDetail = (params) => {
    return axios.get(`/client/ent/branch/news/${params}`);
};

//会员新闻  查询列表
export let getEntMemberNewsList = (params) => {
    return axios.post(`/client/ent/member/news/list`,params);
};

//会员新闻  查询详情
export let getEntMemberNewsDetail = (params) => {
    return axios.get(`/client/ent/member/news/${params}`);
};

//根据类型 查询所在大会员名称
export let getEntMemberInfoName = (params) => {
    return axios.get(`/client/ent/member/info/name/${params}`);
};

//意见反馈新增
export let postEntMemberFeedback = (params) => {
    return axios.post(`/client/ent/member/feedback`,params);
};

//上传付款凭证
export let putEntMemberInfoPay = (params) => {
    return axios.put(`/client/ent/member/info`,params);
};

//修改管理员
export let putUserAccount = (params) => {
    return axios.put(`/sys/user/account`,params);
};

//获取文件
export let getFile = () => {
    return axios.get(`/client/ent/law/news/getFile`);
};

//查询列表
export let putEntLawNewsList = (params) => {
    return axios.post(`/client/ent/law/news/list`,params);
};

//查询详情
export let getEntLawNews = (params) => {
    return axios.get(`/client/ent/law/news/${params}`);
};

//获取市场数据图片
export let getDataUrl = () => {
    return axios.get(`/client/ent/member/info/getDataUrl`);
};









// WEBPACK FOOTER //
// ./src/api/ent.js